import script from "./LilaConfirmCloseTicket.vue?vue&type=script&setup=true&lang=js"
export * from "./LilaConfirmCloseTicket.vue?vue&type=script&setup=true&lang=js"

import "./LilaConfirmCloseTicket.vue?vue&type=style&index=0&id=4dd22b38&lang=css"

const __exports__ = script;

export default __exports__